import { AlertTypeFilterKeyString } from 'AlertsOfVulnerability/types'

export const ALERT_TYPE_FIELDS_INITIAL_VALUES: AlertTypeFilterKeyString = {
  id: '',
  name: '',
  category: '',
  status: '',
  case_type_id: '',
  case_type_name: '',
  case_type_category: '',
  case_type_status: '',
}
